module.exports = __webpack_public_path__ + "img/top-b-back6.598a53fe.png";